import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

    constructor(
            public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public dialogData: any
    ) { }

    ngOnInit(): void { }

    reject(): void {
        this.dialogRef.close(false)
    }

  confirm(): void {
    this.dialogRef.close(true);
  }

}
